/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor>): AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor(), model);
        AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor>): AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.newInstance(<AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsOptimizedAwsAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Number of reservation recommended to purchase
     */
    recommended_number_of_purchase: string;

    /**
     * Expected_Average_Reserved_Resource_Utilization
     */
    expected_average_reserved_resource_utilization: string;

    /**
     * Estimated_Break_Even_Months
     */
    estimated_break_even_months: string;

    /**
     * LookBack_Period_In_Years
     */
    lookback_period_in_years: string;

    /**
     * Term_In_Years
     */
    term_in_years: string;

}
